var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"or-hr-container"},[_c('div'),_vm._v(" "),_c('p',[_vm._v("OR")]),_vm._v(" "),_c('div')])
}]

export { render, staticRenderFns }